"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var hooks_1 = require("../../hooks");
var placement_1 = require("../../types/placement");
var propTypes = {
    placement: PropTypes.oneOf(Object.values(placement_1.Placement)),
    showOverlay: PropTypes.bool,
    allowOverlayClose: PropTypes.bool,
    allowBodyScroll: PropTypes.bool,
    open: PropTypes.bool.isRequired,
    closeFn: PropTypes.func.isRequired,
    style: PropTypes.object,
    overlayStyle: PropTypes.object,
    mods: PropTypes.string,
    overlayMods: PropTypes.string,
    testId: PropTypes.string,
};
var Drawer = function (_a) {
    var placement = _a.placement, children = _a.children, open = _a.open, closeFn = _a.closeFn, showOverlay = _a.showOverlay, allowOverlayClose = _a.allowOverlayClose, allowBodyScroll = _a.allowBodyScroll, style = _a.style, overlayStyle = _a.overlayStyle, mods = _a.mods, overlayMods = _a.overlayMods, testId = _a.testId;
    var showDrawerClass = open ? 'Drawer--open' : '';
    var placementAxisClass = [placement_1.Placement.Left, placement_1.Placement.Right].includes(placement)
        ? 'Drawer--placement-x'
        : 'Drawer--placement-y';
    var classes = (0, helpers_1.getClassName)('Drawer', "Drawer--placement-" + placement, placementAxisClass, showDrawerClass, mods);
    var overlayClasses = (0, helpers_1.getClassName)('Drawer-overlay', open ? 'Drawer-overlay--open' : '', overlayMods);
    var ref = React.useRef(null);
    var setIsBodyScrollLocked = (0, hooks_1.useBodyScrollLock)().setIsBodyScrollLocked;
    var handleClickOutside = React.useCallback(function () {
        if (allowOverlayClose && closeFn && open) {
            setIsBodyScrollLocked(false);
            closeFn();
        }
    }, [allowOverlayClose, closeFn, open]);
    (0, hooks_1.useOnClickOutside)(ref, handleClickOutside);
    React.useEffect(function () {
        setIsBodyScrollLocked(!allowBodyScroll && open);
        return function () { return setIsBodyScrollLocked(false); };
    }, [open, allowBodyScroll]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: ref, className: classes, style: style, "data-testid": testId }, children),
        showOverlay && React.createElement("div", { style: overlayStyle, className: overlayClasses })));
};
Drawer.propTypes = propTypes;
Drawer.defaultProps = {
    placement: placement_1.Placement.Right,
    showOverlay: false,
    allowOverlayClose: true,
    allowBodyScroll: false,
};
exports.default = Drawer;
